export const Navigations = () => {

	// Get all "navbar-burger" elements
	const navbarBurger = document.getElementById('burger');

	if (navbarBurger!==null) {
		// Add a click event on each of them
		navbarBurger.addEventListener('click', () => {
			// Get the target from the "data-target" attribute
			const { target } = navbarBurger.dataset;
			const $target = document.getElementById(target);
			const header = document.getElementsByTagName('global__header')[0];
			const main = document.getElementsByTagName('body')[0];//document.getElementById('main');
	
			if (!main.classList.contains("is-active")) {
				main.dataset.position = window.scrollY;
				main.style.top = `-${main.dataset.position}px`;
			} else {
				// window.screenY = main.dataset.position;
				window.scrollTo(0, main.dataset.position);
				main.style.top = "0";
			}
	
			navbarBurger.classList.toggle('is-active');
			$target.classList.toggle('is-active');
			header.classList.toggle('is-active');
			main.classList.toggle('is-active');
		});
	}

	// const loop = () => {
	// 	const vscroll = document.documentElement.scrollTop;
	// 	const gotop = document.querySelector('.pagetop');
	// 	const header = document.getElementById("whole_header");
	// 	const main = document.getElementById("main");
	// 	if (gotop !== null) {
	// 		if (vscroll >= 200) {
	// 			gotop.classList.add('show');
	// 		} else {
	// 			gotop.classList.remove('show');
	// 		}
	// 	}
		
	// 	if (document.documentElement.clientWidth<=1024) {
	// 		main.style.paddingTop = `${header.clientHeight}px`;
	// 	}
	// 	window.requestAnimationFrame(loop);
	// };
	// loop();
}
